/**
 * GitLab Navigation Constants
 *
 * This file contains shared constants for GitLab navigation integration.
 * It ensures consistency between the navigation handler and tests.
 */

export const GITLAB_ALLOWED_PATHS = [
	'/services',
	'/traces-explorer',
	'/dashboard',
	'/alerts',
	'/exceptions',
	'/service-map',
	'/settings',
	'/logs/logs-explorer',
	'/metrics-explorer/summary',
	'/infrastructure-monitoring/hosts',
	'/messaging-queues/overview',
	'/api-monitoring/explorer',
	'/settings/channels',
	'/settings/api-keys',
	'/settings/service-accounts',
] as const;

export type GitLabAllowedPath = (typeof GITLAB_ALLOWED_PATHS)[number];

export const GITLAB_CRITICAL_ROUTES = [
	{
		description: 'Services listing page',
		routeKey: 'APPLICATION',
		expectedPath: '/services',
	},
	{
		description: 'Traces explorer',
		routeKey: 'TRACES_EXPLORER',
		expectedPath: '/traces-explorer',
	},
	{
		description: 'Logs explorer',
		routeKey: 'LOGS_EXPLORER',
		expectedPath: '/logs/logs-explorer',
	},
	{
		description: 'Metrics explorer summary',
		routeKey: 'METRICS_EXPLORER',
		expectedPath: '/metrics-explorer/summary',
	},
	{
		description: 'Infrastructure monitoring hosts',
		routeKey: 'INFRASTRUCTURE_MONITORING_HOSTS',
		expectedPath: '/infrastructure-monitoring/hosts',
	},
	{
		description: 'Dashboard listing',
		routeKey: 'ALL_DASHBOARD',
		expectedPath: '/dashboard',
	},
	{
		description: 'Messaging queues overview',
		routeKey: 'MESSAGING_QUEUES_OVERVIEW',
		expectedPath: '/messaging-queues/overview',
	},
	{
		description: 'API monitoring explorer',
		routeKey: 'API_MONITORING',
		expectedPath: '/api-monitoring/explorer',
	},
	{
		description: 'Alerts listing',
		routeKey: 'LIST_ALL_ALERT',
		expectedPath: '/alerts',
	},
	{
		description: 'Exceptions listing',
		routeKey: 'ALL_ERROR',
		expectedPath: '/exceptions',
	},
	{
		description: 'Service map',
		routeKey: 'SERVICE_MAP',
		expectedPath: '/service-map',
	},
	{
		description: 'Settings',
		routeKey: 'SETTINGS',
		expectedPath: '/settings',
	},
] as const;
